import React, { useState, useContext, FC, Key, useEffect } from "react"
const ViewJobDetails = () => {
  return (
    <div>
      <h1>View Job Details</h1>
    </div>
  )
}
export default ViewJobDetails
